import { analyticsService } from "../../services";
import { storageService } from "../../services/storage";
import { ActionTypes } from "../constants/actionTypes";
import { alertError } from "./alertActions";

export const storageActions = {
    getApplications,
    getPrimariesForApplication,
    getSecondaryForPrimary,
};

function getApplications(access) {
    return (dispatch) => {
        dispatch(request({}));
        storageService.getApplications(access).then((Applications) => {
            dispatch(success(Applications))
            analyticsService.logStorageEvent(access, '3',)
        }).catch((err) => {
            console.error(err)
            dispatch(failure(err))
            dispatch(alertError(err))
        })
    };
    function request(user) {
        return { type: ActionTypes.STORAGE_APPLICATIONS_REQUEST, user };
    }
    function success(applications) {
        return { type: ActionTypes.STORAGE_APPLICATIONS_SUCCESS, applications };
    }
    function failure(error) {
        return { type: ActionTypes.STORAGE_APPLICATIONS_FAILURE, error };
    }
}

function getPrimariesForApplication(access, application_id) {
    return (dispatch) => {
        dispatch(request({}));
        storageService.getPrimaries(access, application_id).then((Primaries) => {
            dispatch(success(Primaries))
            analyticsService.logStorageEvent(access, '3', application_id)
        }).catch((err) => {
            console.error(err)
            dispatch(failure(err))
            dispatch(alertError(err))
        })
    };
    function request(user) {
        return { type: ActionTypes.APPLICATION_PRIMARY_REQUEST, user };
    }
    function success(primaries) {
        return { type: ActionTypes.APPLICATION_PRIMARY_SUCCESS, primaries };
    }
    function failure(error) {
        return { type: ActionTypes.APPLICATION_PRIMARY_FAILURE, error };
    }
}

function getSecondaryForPrimary(access, id) {
    return (dispatch) => {
        dispatch(request({}));
        storageService.getLevel2ForPrimary(access, id)
            .then((Secondaries) => {
                dispatch(success(Secondaries));
                analyticsService.logStorageEvent(access, '4', null, id)
            })
            .catch((err) => {
                console.error(err);
                dispatch(failure(err));
                dispatch(alertError(err));
            });
    };
    function request(user) {
        return { type: ActionTypes.APPLICATION_SECONDARY_REQUEST, user };
    }
    function success(secondaries) {
        return { type: ActionTypes.APPLICATION_SECONDARY_SUCCESS, secondaries };
    }
    function failure(error) {
        return { type: ActionTypes.APPLICATION_SECONDARY_FAILURE, error };
    }
}